export default {
    Active(state, val){state.access = val},
    set_asideStorage(state, val){ state.asideStorage = val; },
    ActiveLateral(state, val) { state.lateralShow = val; },
    set_refresh_list(state, val){ state.refresh_list = val; },
    set_finished(state, payload){ state.events_finished = payload;},
	set_pending(state, payload){ state.events_pending = payload;},
}
